import Vue from 'vue'
import VueRouter from 'vue-router'
import Resource from 'vue-resource'
import Home from '../views/Home.vue'
import Inprogress from '../components/Inprogress.vue'
import Forgotpassword from '../components/Forgotpassword.vue'
import store from '../store/index'
import { isMobileOnly } from 'mobile-device-detect'
import Dashboard from '@/components/Dashboard.vue'
import Site404 from '@/components/Site404.vue'

Vue.use(VueRouter)
Vue.use(Resource)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: (to, from, next) => {
      // console.log('/', store.getters.jwt)
      // if (store.getters.jwt) {
      //   next()
      // } else {
      //   next('/login')
      // }
      if (store.state.user.privileges.guest) {
        store.commit('SET_GUEST', false)
        next()
      } else {
        next()
      }
    }
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
  },
  {
    path: '/beach',
    name: 'Beach',
    component: Dashboard,
    beforeEnter: (to, from, next) => {
      // console.log(store.state.beach)
      // next()
      store.dispatch('beach/getBeach', store.state.hotels.activehotel._id).then(response => {
        console.log('beach found')
        next()
      }, error => {
        console.log('beach not found ', error)
        next('/404')
      })
    }
  },
  {
    path: '/404',
    name: '404',
    component: Site404
  },
  {
    path: '/inprogress',
    name: 'Inprogress',
    component: Inprogress,
    beforeEnter: (to, from, next) => {
      // console.log('/', store.getters.jwt)
      if (!isMobileOnly) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/home/:result',
    name: 'Home',
    component: Home
  },
  {
    path: '/beach/:beachid',
    name: 'Beach',
    beforeEnter: (to, from, next) => {
      // console.log(to.params.beachid)
      store.dispatch('beach/getBeach', to.params.beachid).then(response => {
        console.log('beach found')
        next('/beach')
      }, error => {
        console.log('beach not found')
        next('/404')
      })
    }
  },
  {
    path: '/password-forgot/:token',
    name: 'Forgotpassword',
    component: Forgotpassword
  }
  // {
  //   path: '/home/:result',
  //   name: 'Home',
  //   component: Home
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
